<template>
  <div class="my-context-menu">
    <b-dropdown
      ref="menu"
      class="my-dropdown"
      lazy
      no-caret
      right
      toggle-class="text-decoration-none"
      variant="link"
    >
      <template #button-content>
        <font-awesome-icon
          icon="ellipsis-v"
          size="xl"
        />
      </template>
      <!-- <b-dropdown-item>{{ file.label }}</b-dropdown-item> -->
      <b-dropdown-item
        v-if="showOpen"
        @click="openDir"
      >Apri</b-dropdown-item>
      <b-dropdown-item
        v-if="showDownload"
        @click="download"
      >Download</b-dropdown-item>
      <b-dropdown-item
        v-if="showRename"
        @click="rename"
      >
        Rinomina
      </b-dropdown-item>
      <b-dropdown-item
        v-if="showNewVersion"
        @click="newVersion"
      >Nuova Versione</b-dropdown-item>
      <b-dropdown-item
        v-if="showNewCopy"
        @click="makeCopy"
      >Crea una Copia</b-dropdown-item>
      <b-dropdown-item
        v-if="showMove"
        @click="move"
      >
        Sposta
      </b-dropdown-item>
      <b-dropdown-item
        v-if="showDelete"
        @click="_delete"
      >
        Elimina
      </b-dropdown-item>
      <b-dropdown-item
        v-if="showExpiration"
        @click="expiration"
      >
        Scadenza…
      </b-dropdown-item>
      <b-dropdown-item
        v-if="showShare"
        @click="share"
      >
        Condividi
      </b-dropdown-item>
      <b-dropdown-item
        v-if="showInfo"
        @click="detail"
      >
        Info
      </b-dropdown-item>
      <b-dropdown-item
        v-if="showRestore"
        @click="restore"
      >
        Ripristina
      </b-dropdown-item>
      <b-dropdown-item
        v-if="showForceDelete"
        @click="forceDelete"
      >Elimina Definitivamente
      </b-dropdown-item>
      <!-- <b-dropdown-item disabled> Disabled action </b-dropdown-item> -->
    </b-dropdown>
  </div>
</template>

<script>
import { BDropdown, BDropdownItem } from 'bootstrap-vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import useMyStore from '@/services/useMyStore'
import objectsRepository from '@/api/objectsRepository'
import bulkDownloadRequest from '@/mixins/bulkDownloadRequest'

export default {
  name: 'FileContextMenu',
  components: {
    BDropdownItem,
    BDropdown,
    FontAwesomeIcon,
  },
  mixins: [bulkDownloadRequest],
  props: {
    file: {
      type: Object,
      required: true,
    },
    selectedFiles: {
      type: Array,
      required: true,
    },
    staging: {
      type: Boolean,
      default: () => false,
    },
    trashed: {
      type: Boolean,
      default: () => false,
    },
  },
  setup() {
    const { currentFolder, currentObject, uploadMethod } = useMyStore()

    return {
      currentFolder, currentObject, uploadMethod,
    }
  },
  data() {
    return {
      isOpen: false,
    }
  },
  computed: {
    currentFileIsSelected() {
      return this.file.selected && this.selectedFiles.length > 1
    },
    showOpen() {
      return this.file.is_folder && !this.currentFileIsSelected && !this.staging && !this.trashed
    },
    showDownload() {
      return !this.staging && !this.trashed
    },
    showRename() {
      return !this.currentFileIsSelected && !this.staging && !this.trashed && this.$can('update', 'object')
    },
    showNewVersion() {
      return !this.file.is_folder && !this.currentFileIsSelected && !this.staging && !this.trashed && this.$can('upload', 'object')
    },
    showNewCopy() {
      return !this.file.is_folder && !this.currentFileIsSelected && !this.staging && !this.trashed && this.$can('upload', 'object')
    },
    showMove() {
      return !this.trashed && this.$can('move', 'object')
    },
    showDelete() {
      return !this.trashed && this.$can('delete', 'object')
    },
    showExpiration() {
      return !!this.file.is_folder && !this.currentFileIsSelected && !this.staging && !this.trashed && this.$can('update', 'object')
    },
    showShare() {
      return !this.currentFileIsSelected && !this.staging && !this.trashed && this.$can('publish', 'object')
    },
    showInfo() {
      return !this.currentFileIsSelected && !this.staging && !this.trashed && this.$can('update', 'object') // todo: qualcosa di meglio
    },
    showRestore() {
      return this.trashed && !this.staging
    },
    showForceDelete() {
      return this.trashed && !this.staging
    },
    ids() {
      if (this.currentFileIsSelected) {
        return this.selectedFiles.map(a => a.id)
      }
      return [this.file.id]
    },
  },
  methods: {
    open() {
      const dropdown = this.$refs.menu
      dropdown.show()
    },
    openDir() {
      this.currentFolder = this.file.id
    },
    async download() {
      if (!this.file.is_folder && !this.currentFileIsSelected) {
        const { data } = await objectsRepository.download(
          this.file.version.at(-1).uuid,
        )
      window.open(data.data.link, '_blank')

        // const fileLink = document.createElement('a')

        // fileLink.href = data.data.link
        // fileLink.setAttribute('target', '_blank')
        // fileLink.setAttribute('download', this.file.label)
        // document.body.appendChild(fileLink)

        // fileLink.click()
      } else {
        this.bulkDownload()
      }
    },
    bulkDownload() {
      this.requestBulkDownload(this.ids, this.currentFolder)
    },
    rename() {
      this.currentObject = this.file.id
      this.$bvModal.show('rename-modal')
    },
    newVersion() {
      this.uploadMethod = 'copy'
      this.currentObject = this.file.id
      this.$bvModal.show('upload-modal')
    },
    async makeCopy() {
      this.currentObject = this.file.id
      this.$bvModal.show('newcopy-modal')
    },
    move() {
      this.currentObject = this.file.id
      if (this.staging) {
        this.$bvModal.show('stagingmove-modal')
      } else {
        this.$bvModal.show('move-modal')
      }
    },
    _delete() {
      this.currentObject = this.file.id
      if (this.staging) {
        this.$bvModal.show('stagingdelete-modal')
      } else {
        this.$bvModal.show('remove-modal')
      }
    },
    expiration() {
      this.currentObject = this.file.id
      this.$bvModal.show('expiration-modal')
    },
    detail() {
      this.currentObject = this.file.id
      this.$bvModal.show('detail-modal')
    },
    share() {
      this.currentObject = this.file.id
      this.$bvModal.show('share-modal')
    },
    restore() {
      this.currentObject = this.file.id
      this.$bvModal.show('restore-modal')
    },
    forceDelete() {
      this.currentObject = this.file.id
      this.$bvModal.show('forceDelete-modal')
    },
  },
}
</script>

<style lang="scss">
.my-dropdown {
  .btn {
    padding: 0 !important;
  }
}

#__BVID__134__BV_toggle_ {
  padding: 0 !important;
}

.my-card > .btn {
  padding: 0 !important;
}
</style>
